import { useEffect, useState } from "react";
import axios from "axios";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export default function RedeemPointsPrompt({ onRedeemed }) {
  const [loyalty, setLoyalty] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => axios.get(`${API}/me/loyalty`).then((r) => setLoyalty(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const best = (loyalty?.available_rewards || []).slice(-1)[0];
  if (!best) return null;

  const redeem = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/me/loyalty/redeem`, { points: best.points });
      toast.success(`${best.label} added to your wallet`);
      onRedeemed?.(data.wallet_credits_cents);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Redeem failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={redeem}
      disabled={busy}
      className="w-full mt-3 flex items-center gap-2 rounded-lg px-3 py-2.5 border border-emerald-500/40 bg-emerald-500/10 hover:bg-emerald-500/20 text-left transition-colors disabled:opacity-50"
      data-testid="booking-redeem-points-btn"
    >
      <Gift className="w-4 h-4 text-emerald-300 shrink-0" />
      <span className="text-xs text-white">
        <b>You have {loyalty.points} points.</b> {busy ? "Converting…" : `Tap to turn ${best.points} pts into a ${best.label} for this trip`}
      </span>
    </button>
  );
}
